import React from "react";
import { AppContext } from "@patron/utils/context";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";
import timeZone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";

import dayjs from "dayjs";

export const SetDefaultLocale = () => {
  const { localAppState } = React.useContext(AppContext);
  const { defaultStartWeek } = localAppState.tenantCompanyDetails?.config.global || 0;
  dayjs.locale("nl");
  dayjs.extend(updateLocale);
  dayjs.extend(utc);
  dayjs.extend(timeZone);
  dayjs.extend(advancedFormat);
  dayjs.updateLocale("nl", {
    weekStart: defaultStartWeek,
  });
  dayjs.tz.setDefault("Europe/Paris");
};
